export class ActiveDirectoryModel{

  ativo?: boolean;
  nome?: string;
  dominio?: string;
  ldapUrl?: string;
  ldapManagerFilter?: string;
  ldapManagerBase?: string;
  ldapManagerDn?: string;
  ldapManagerPassword?: string;

}
